export default __webpack_public_path__ + "static/media/connectivity-tablet.7aad1e04.jpg";